const apiKey = 'c8d26c5d39ae1d0b04801cab4b360e9c';

export default apiKey;